import { ComponentsOverrides, Theme } from "@mui/material";

type MuiAutocomplete = {
  styleOverrides: ComponentsOverrides<Theme>["MuiAutocomplete"];
};

const muiAutocomplete: MuiAutocomplete = {
  styleOverrides: {
    root: {
      "& .MuiFilledInput-root": {
        paddingTop: "0",
      },
    },
  },
};

export default muiAutocomplete;
